import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { COMPANY, FOOTER, CONTACT_PAGE } from "../config/content";

export default function Footer() {
  const openWhatsApp = () => {
    const url = `https://wa.me/${COMPANY.whatsappNumber}?text=${encodeURIComponent(COMPANY.whatsappMessage)}`;
    window.open(url, '_blank');
  };

  return (
    <footer className="py-12 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <img 
              src={COMPANY.logo}
              alt={COMPANY.name}
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-slate-400 text-sm leading-relaxed max-w-md">
              {FOOTER.description}
            </p>
            
            {/* WhatsApp Button */}
            <button
              onClick={openWhatsApp}
              className="mt-4 flex items-center gap-2 bg-[#25D366] hover:bg-[#20BA5C] text-white px-4 py-2 text-sm transition-colors"
            >
              <MessageCircle size={18} />
              Chat on WhatsApp
            </button>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              {FOOTER.quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-slate-400 hover:text-[#0047FF] transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/achievements" className="text-slate-400 hover:text-[#0047FF] transition-colors">
                  Achievements
                </Link>
              </li>
              <li>
                <Link to="/downloads" className="text-slate-400 hover:text-[#0047FF] transition-colors">
                  Downloads
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>
                <a href={`tel:${COMPANY.phone.replace(/\s/g, '')}`} className="flex items-center gap-2 hover:text-[#0047FF] transition-colors">
                  <Phone size={14} />
                  {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-[#0047FF] transition-colors">
                  <Mail size={14} />
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="mt-1 flex-shrink-0" />
                <span>{CONTACT_PAGE.offices[0]?.address.split(',').slice(0, 3).join(',')}</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-slate-800 text-center text-sm text-slate-500">
          <p>&copy; {new Date().getFullYear()} {FOOTER.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
